<template>
  <div class="col-span-12 grid grid-cols-8 col-gap-8">
    <VueCtkDateTimePicker v-model="date_range"
                          class="col-span-2"
                          format="YYYY-MM-DD"
                          formatted="L"
                          :label="$t('dateLabel')"
                          :range="true"
                          :auto-close="true"
                          :custom-shortcuts="date_shortcuts"
                          :locale="$i18n.locale"
                          :no-clear-button="true"
                          :no-button="true"
                          color="#486680"/>
    <BaseSelect :value="group_by" class="col-span-2"
                :options="filters_data.group_list"
                :select-label="$t('detailingLabel')"
                track-by="value"
                :label="`name_${$i18n.locale}`"
                :searchable="true"
                :show-labels="false"
                :allow-empty="false"
                @select="handleChangeFilter({name:'group_by',value:$event})"/>
    <BaseSelect :value="income_structure" class="col-span-2"
                :options="filters_data.income_structure_list"
                :select-label="$t('incomeStructureLabel')"
                track-by="value"
                :label="`name_${$i18n.locale}`"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                @select="handleChangeIncomeStructure"/>
    <BaseSelect v-if="income_structure.value==='source'"
                :value="income_source"
                class="col-span-2"
                :options="incomeSourcesList"
                :select-label="$t('incomeLabel')"
                track-by="id"
                label="title"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                @select="handleChangeFilter({name:'income_source',value:$event})"/>
  </div>
</template>

<script>
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ReportIncomeFilters",
  components: {BaseSelect},
  props: {
    date: {
      type: Object
    },
    group_by: {
      type: Object
    },
    income_structure: {
      type: Object
    },
    income_source: {
      type: Object
    },
  },
  computed: {
    ...mapState('reports/report_filters', ['filters_data']),
    ...mapGetters('space/incomes', ['sortedIncomes']),
    incomeSourcesList() {
      return [{id: 'all', title: this.$t('allIncomes')}, ...this.sortedIncomes]
    },
    date_shortcuts() {
      return [
        {
          key: 'thisMonth', label: 'Месяц',
          value: () => ({start: this.$moment().startOf('month'), end: this.$moment()})
        },
        {
          key: 'thisQuarter', label: 'Квартал',
          value: () => ({start: this.$moment().startOf('quarter'), end: this.$moment()})
        },
        {
          key: 'thisYear', label: 'Этот год',
          value: () => ({start: this.$moment().startOf('year'), end: this.$moment()})
        },
        {
          key: 'year', label: 'Год',
          value: () => ({start: this.$moment().subtract(12, 'month'), end: this.$moment()})
        },
        {
          key: 'all', label: 'С начала',
          value: this.$store.getters["space/spaceFirstTransactions"]
        },
      ]
    },
    date_range: {
      get() {
        return this.date;
      },
      set(value) {
        this.$emit('updateFilter', {name: 'date', value})
        this.$store.commit(`reports/report_income/resetPagination`);
        this.$emit('fetchReport',true)
      }
    },
  },
  methods: {
    handleChangeIncomeStructure(value) {
      this.$emit('updateFilter', {name: 'income_structure', value: value})
      this.$emit('updateFilter', {name: 'income_source', value: this.incomeSourcesList[0]})
      this.$emit('fetchReport')
    },
    handleChangeFilter(data) {
      this.$emit('updateFilter', data)
      this.$emit('fetchReport')
    }
  },
  created() {
    this.$emit('updateFilter', {name: 'income_source', value: this.incomeSourcesList[0]})
  },
  i18n: {
    messages: {
      en: {
        dateLabel: 'Date period',
        detailingLabel: 'Detailing',
        incomeStructureLabel: 'Incomes structure',
        incomeLabel: 'Income source',
        allIncomes: 'All'
      },
      ru: {
        dateLabel: 'Дата операций',
        detailingLabel: 'Детализация',
        incomeStructureLabel: 'Структура доходов',
        incomeLabel: 'Источник дохода',
        allIncomes: 'Все источники'
      }
    }
  }
}
</script>

<style scoped>

</style>